import { Layer, Line } from 'react-konva';
import { CANVAS_WIDTH, CANVAS_HEIGHT, GRID_SIZE } from '../canvasConstants';

export const GridLayer = () => {
  const lines = [];
  for (let x = 0; x <= CANVAS_WIDTH; x += GRID_SIZE)
    lines.push(
      <Line key={`v${x}`} points={[x, 0, x, CANVAS_HEIGHT]} stroke="#f0f0f0" strokeWidth={0.5} />
    );
  for (let y = 0; y <= CANVAS_HEIGHT; y += GRID_SIZE)
    lines.push(
      <Line key={`h${y}`} points={[0, y, CANVAS_WIDTH, y]} stroke="#f0f0f0" strokeWidth={0.5} />
    );
  return <Layer listening={false}>{lines}</Layer>;
};
